export enum LocalisationEntities {
	COMMON = "common",
	DATE = "date",
	ERROR = "error"
}

export enum SupportedLanguages {
	ENGLISH = "en",
	RUSSIAN = "ru"
}
